import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'
import FixtureTemplate from './FixtureTemplate'

function AllFixtures() {
    const [fixtures, setFixtures] = useState([])

    useEffect(() => {
        try {
            const fixturesRef = firestore.collection('fixtures')
            fixturesRef.orderBy('date').onSnapshot(({ docs }) => {
                const fixtures = docs.map((doc) => {
                    return { id: doc.id, ...doc.data() }
                })
                setFixtures(fixtures)
            })
        } catch (error) {}
    }, [])

    return (
        <div>
            {fixtures?.map((fixture, index) => {
                return (
                    <FixtureTemplate
                        fixture={fixture}
                        key={index}
                        fixtureId={fixture.id}
                    />
                )
            })}
        </div>
    )
}
export default AllFixtures
